// extracted by mini-css-extract-plugin
module.exports = {"mCard":"vg","image":"wg","imageNoBackground":"xg"};